<template>
  <div class="hotel-show-map-container">
    <div
      id="map"
      class="hotels-show-page-map"
    />
    <div class="distance" />
  </div>
</template>

<script>
/* global google */
export default {

  props: {
    hotelLatitude: {
      required: true,
      type: Number
    },
    hotelLongitude: {
      required: true,
      type: Number
    },
    hotelName: {
      required: true,
      type: String
    },
    eventName: {
      required: true,
      type: String
    },
    eventLongitude:{
      required: true,
      type: Number
    },
    eventLatitude:{
      required: true,
      type: Number
    }
  },
  data(){
    return{
      eventIcon: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png',
      hotelIcon: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'
    }
  },

  async mounted() {
    try {
      const geocoder = new google.maps.Geocoder()
      let bounds = new google.maps.LatLngBounds ()
      let directionsService = new google.maps.DirectionsService()
      let directionsRenderer = new google.maps.DirectionsRenderer({suppressMarkers: true})

      const map = new google.maps.Map(document.getElementById('map'), {
        center: {lat: this.hotelLatitude, lng: this.hotelLongitude},
        zoom: 15
      })
      this.mapMarker(map, this.hotelLatitude, this.hotelLongitude, this.hotelIcon, this.hotelName)
      if(this.eventLatitude && this.eventLongitude){
        this.mapMarker(map,this.eventLatitude, this.eventLongitude, this.eventIcon, this.eventName)
        this.insertMapIcons(map, this.eventLatitude, this.eventLongitude, bounds)
        directionsRenderer.setMap(map) // Existing map object displays directions
        // Create route from existing points used for markers
        const route = {
          origin: {lat:this.hotelLatitude, lng:this.hotelLongitude},
          destination: {lat:this.eventLatitude, lng:this.eventLongitude},
          travelMode: 'DRIVING'
        }
        directionsService.route(route,
          function(response, status) { // anonymous function to capture directions
            if (status !== 'OK') {
              return
            }
            else {
              directionsRenderer.setDirections(response) // Add route to the map
              let directionsData = response.routes[0].legs[0] // Get data about the mapped route
              if (!directionsData) {
                return
              }
              else {
                // document.querySelector('.distance').innerHTML += ' Driving distance is ' + directionsData.distance.text + ' (' + directionsData.duration.text + ').'
              }
            }
          })
      }
      else {
        geocoder.geocode({ address: '9300 Harris Corners Pkwy #120, Charlotte, NC 28269' },
          (results, status) => {
            if (status !== 'OK' || !results[0]) {
              throw new Error(status)
            }
            let location=results[0].geometry.location
            this.mapMarker(map, location.lat(), location.lng(), this.eventIcon)
            this.insertMapIcons(map, location.lat(), location.lng(), bounds)
          })
      }
      // this.setMapDimensions()
    } catch (error) {
      console.error(error)
    }
  },
  methods: {
    insertMapIcons(map, lat, lng, bounds){
      map.setCenter({lat:(this.hotelLatitude + lat)/2, lng:(this.hotelLongitude + lng)/2})
      bounds.extend(new google.maps.LatLng(lat, lng))
      bounds.extend(new google.maps.LatLng(this.hotelLatitude, this.hotelLongitude))
      map.fitBounds(bounds)
    },
    mapMarker(map, lat, lng, marker, name=''){
      let mapMarker = new google.maps.Marker({
        position: {lat, lng},
        latlng: new google.maps.LatLng(lat, lng),
        map: map,
        icon:marker
      })
      let infoWindow = new google.maps.InfoWindow({
        content: name
      })
      mapMarker.addListener('click', function(){
        infoWindow.open(map, mapMarker)
      })
    },
    // setMapDimensions() {
    //   document.getElementById('map').style.width = '100%'
    //   document.getElementById('map').style.height = 'auto'

    // }
  }
}
</script>
